<template>
  <div
    class="ShoppingRuleMessage py-12 pl-12 pr-16 items-center gap-6 mt-12 rounded-4 mb-24 type-xs desk:type-sm"
    :class="{
      'bg-success text-lightest': design === 'default',
      'bg-brightYellow': design === 'warning',
    }"
  >
    <div class="flex gap-6 items-start">
      <img
        :src="design === 'default' ? '/icons/info-inv.svg' : '/icons/info.svg'"
        class="w-16 h-16 desk:top-4 relative"
        alt="info"
      >
      <span v-html="message" />
    </div>
  </div>
</template>

<script setup lang="ts">

withDefaults(defineProps<{
  message: string,
  design?: 'default' | 'warning',
}>(), {
  design: 'default',
});

</script>

<style scoped lang="postcss">

</style>
